module.exports = __webpack_public_path__ + "img/item-2.f14e9e18.png";